import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Snackbar from '@mui/material/Snackbar';

import { Alert } from 'ui';
import { usePrevious } from 'shared/hooks';
import { removeNotificationAction } from 'store/notifications/notificationsActions';

const SnackbarNotifications = ({ notification, removeNotification }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(null);
  const [variant, setVariant] = useState(undefined);

  const previousNotification = usePrevious(notification);

  const processQueue = () => {
    if (notification) {
      setMessage(notification.message);
      setVariant(notification.variant);
      setOpen(true);

      removeNotification(notification.id);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  const handleExited = () => {
    processQueue();
  };

  useEffect(() => {
    if (notification !== previousNotification) {
      if (notification) {
        if (open) {
          setOpen(false);
        } else {
          processQueue();
        }
      }
    }
    // eslint-disable-next-line
  }, [notification]);

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      onClose={handleClose}
      TransitionProps={{
        onExited: handleExited,
      }}
      open={open}
      autoHideDuration={5000}
    >
      <div>
        {message && <Alert message={message} variant={variant} />}
      </div>
    </Snackbar>
  );
};

const mapStateToProps = state => ({
  notification: state.notifications[0] || null,
});

const mapDispatchToProps = dispatch => ({
  removeNotification: id => dispatch(removeNotificationAction(id)),
});

const ConnectedNotifications = connect(mapStateToProps, mapDispatchToProps)(SnackbarNotifications);

SnackbarNotifications.defaultProps = {
  notification: null,
};

SnackbarNotifications.propTypes = {
  notification: PropTypes.shape({
    variant: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
    message: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  }),
  removeNotification: PropTypes.func.isRequired,
};

export default ConnectedNotifications;
